{
  "schema": "source-fingerprint-v2",
  "contentHash": "8db5dd24ed3ae95ba4133342b17ecde70ccbf77bdff43c26b618b254e0b2db06",
  "metadata": null
}
